// extracted by mini-css-extract-plugin
module.exports = {"logoWrapper":"Logos_logoWrapper__zxRIC","title":"Logos_title__2Gz5k","flexWrapper":"Logos_flexWrapper__EIPaX","flex":"Logos_flex__YzJdF"};